/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PartyPerformanceAnalysisQueryVariables = {|
  partyId: string,
  days?: ?number,
  weeks?: ?number,
  month?: ?number,
  all?: ?boolean,
|};
export type PartyPerformanceAnalysisQueryResponse = {|
  +partyPerformanceAnalysis: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +created: any,
        +updatedPrice: number,
      |}
    |}>
  |}
|};
export type PartyPerformanceAnalysisQuery = {|
  variables: PartyPerformanceAnalysisQueryVariables,
  response: PartyPerformanceAnalysisQueryResponse,
|};
*/


/*
query PartyPerformanceAnalysisQuery(
  $partyId: ID!
  $days: Int
  $weeks: Int
  $month: Int
  $all: Boolean
) {
  partyPerformanceAnalysis(partyId: $partyId, weeks: $weeks, days: $days, month: $month, all: $all) {
    edges {
      node {
        created
        updatedPrice
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "all"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "days"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "partyId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weeks"
},
v5 = [
  {
    "kind": "Variable",
    "name": "all",
    "variableName": "all"
  },
  {
    "kind": "Variable",
    "name": "days",
    "variableName": "days"
  },
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  },
  {
    "kind": "Variable",
    "name": "partyId",
    "variableName": "partyId"
  },
  {
    "kind": "Variable",
    "name": "weeks",
    "variableName": "weeks"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedPrice",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PartyPerformanceAnalysisQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PartyStockHistoryNodeConnection",
        "kind": "LinkedField",
        "name": "partyPerformanceAnalysis",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PartyStockHistoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PartyStockHistoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PartyPerformanceAnalysisQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "PartyStockHistoryNodeConnection",
        "kind": "LinkedField",
        "name": "partyPerformanceAnalysis",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PartyStockHistoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PartyStockHistoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31028e01f101c9b721a1074a51730401",
    "id": null,
    "metadata": {},
    "name": "PartyPerformanceAnalysisQuery",
    "operationKind": "query",
    "text": "query PartyPerformanceAnalysisQuery(\n  $partyId: ID!\n  $days: Int\n  $weeks: Int\n  $month: Int\n  $all: Boolean\n) {\n  partyPerformanceAnalysis(partyId: $partyId, weeks: $weeks, days: $days, month: $month, all: $all) {\n    edges {\n      node {\n        created\n        updatedPrice\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd2dd9a4971a8142c2976510a14aeba7a';

module.exports = node;
